import { ProgressSpinner } from 'primereact/progressspinner'
import { classNames } from 'primereact/utils'
import React from 'react'

const Loader = ({ loading, querySelector }) => {
    // console.log(document.querySelector(querySelector));
    return (
        <div className={classNames('progressSpinner-container', { showSpinner: loading })}
            style={{
                height: document.querySelector(querySelector)?.offsetHeight,
                width: document.querySelector(querySelector)?.offsetWidth,
                zIndex: 999999
            }}>
            <ProgressSpinner />
        </div>
    )
}

export default Loader